module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section patient-forms"
  }, [_c('div', {
    staticClass: "section__container patient-forms__container"
  }, [_c('div', {
    staticClass: "section__header patient-forms__header"
  }, [_c('div', {
    staticClass: "section__header-title patient-forms__header-title"
  }, [_vm._v(_vm._s(_vm.content.patient_forms.title))]), _c('div', {
    staticClass: "section__header-subtitle patient-forms__header-subtitle"
  }, [_vm._v(_vm._s(_vm.content.patient_forms.subtitle))])]), _c('div', {
    staticClass: "patient-forms__text",
    domProps: {
      "innerHTML": _vm._s(_vm.content.patient_forms.text)
    }
  }, [_vm._v(_vm._s(_vm.content.patient_forms.text))]), _c('ul', {
    staticClass: "patient-forms__forms"
  }, _vm._l((_vm.content.patient_forms.forms), function(item) {
    return _c('li', {
      staticClass: "patient-forms__form"
    }, [_vm._v(_vm._s(item.name)), _c('span'), _c('a', {
      attrs: {
        "href": item.link_01,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.link_01_label))]), _c('span', [_vm._v("|")]), _c('a', {
      attrs: {
        "href": item.link_02,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.link_02_label))])])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b195acf"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-patient-forms/custom-patient-forms.pug
// module id = 524
// module chunks = 1